import { useCallback } from "react";
import { getAge, getDobFromAge } from "../utility/utilityFunctions";
import { toast } from 'react-toastify';
import { useSelector } from "react-redux";

export const useTravellerHandlers = (formik) => {
    const mastersData = useSelector(state => state.MastersData);
    const handleDOBChange = useCallback((index, dob) => {
        const age = getAge(dob);
        formik.setFieldValue(`travellers[${index}].dob`, dob);
        formik.setFieldValue(`travellers[${index}].age`, age);
    }, [formik]);

    const addTraveller = useCallback(() => {
        if (formik.values.travellers.length < 4) {
            formik.setFieldValue("travellers", [
                ...formik.values.travellers,
                { dob: '', age: null, relation:'' }
            ]);
        } else {
            toast.warn('Maximum 4 travellers are allowed');
        }
    }, [formik]);

    const removeTraveller = useCallback((index) => {
        const updatedTravellers = [...formik.values.travellers];
        updatedTravellers.splice(index, 1);
        formik.setFieldValue("travellers", updatedTravellers);
    }, [formik]);


    const handleTravellerInput = useCallback((index,value,input) => {
        if (input == 'age') {
            formik.setFieldValue(`travellers[${index}].age`, value);
            formik.setFieldValue(`travellers[${index}].dob`, getDobFromAge(value));
            index === 0 && formik.setFieldValue(`travellers[${index}].relation`, mastersData.relationList.find(r => r?.RelationName?.toLowerCase() == 'self')?.RelationID);
        } else if (input =='relation') {
            formik.setFieldValue(`travellers[${index}].relation`, value);
        }
    }, [formik]);

    const handleTravellerAge = useCallback((index,age) => {
        formik.setFieldValue(`travellers[${index}].age`, age);
    });

    return {
        handleDOBChange,
        addTraveller,
        removeTraveller,
        handleTravellerAge,
        handleTravellerInput
    };
};

